if (!customElements.get('custom-procuct-component')) {
  customElements.define('custom-product-component', class CustomProductComponent extends HTMLElement {
    constructor() {
      super();

      this.constSingleId = 'single';
      this.constQueenId = 'queen';
      this.constKingId = 'king';

      this.selectedPackageType = this.constSingleId; // defaultはsingle

      this.productData = document.querySelector('product-data').getProductData();
      this.lotData = this.productData.lot;
      this.variantData = this.productData.variant;

      this.setDomElement()

      this.initPackagePicker();
      this.initTotalQuantity();
      this.initCartItemBoard();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    initPackagePicker() {
      this.elVariantContainer = this.querySelector('.js-variant-container');
      this.elVariantTemplate = this.querySelector('.js-variant-template');
      this.elPackageTypePicker = this.querySelectorAll('.js-package-type-picker');

      if (this.elPackageTypePicker.length > 0) {
        // queen || king がある場合
        this.elPackageTypePicker.forEach(el => {
          const targetRadio = el.querySelector('input[type="radio"]');

          if (targetRadio.checked) this.updateVariant(targetRadio.value);
  
          targetRadio.addEventListener('change', (evt) => {
            const packageType = evt.target.value;
            this.selectedPackageType = packageType;
            this.togglePickerClass(packageType);
            this.switchPackageContent(packageType);
            this.updateVariant(packageType);
            this.updateTotalQuantity(packageType);
            this.toggleTotalContent(packageType);
            this.initCartItemBoard();
            this.handleErrorMessage();
          })
        })
      } else {
        // singleのみの場合
        this.updateVariant(this.selectedPackageType);
      }
    }

    updateVariant(packageType) {
      while(this.elVariantContainer.lastChild) {
        this.elVariantContainer.removeChild(this.elVariantContainer.lastChild);
      }

      let fragment = document.createDocumentFragment();
      const dataList = this.variantData[packageType];

      dataList.forEach(data => {
        const elVariant = this.elVariantTemplate.content.cloneNode(true);
        elVariant.querySelector('.js-variant-title').textContent = data.title;
        if (data.information) {
          elVariant.querySelector('.js-variant-information').textContent = `${data.information}`;
        }

        if (data.comparePrice) {
          // sale
          elVariant.querySelector('.js-variant-price').classList.add('is-sale');
          elVariant.querySelector('.js-variant-price-sale').textContent = `${data.price.toLocaleString()}円`;
          elVariant.querySelector('.js-variant-price-normal').textContent = `${data.comparePrice.toLocaleString()}円`;
        } else {
          // 通常価格
          elVariant.querySelector('.js-variant-price-normal').textContent = `${data.price.toLocaleString()}円`;
        }

        const elVariantQuantityCell = elVariant.querySelector('.js-variant-quantity-cell');
        const elVariantQuantity = elVariant.querySelector('.js-variant-quantity');
        const elVariantQuantityInput = elVariant.querySelector('.js-variant-quantity-input');

        if (data.isAvailable) {
          elVariantQuantityInput.setAttribute('data-variant-id',data.id);
        } else {
          elVariantQuantityCell.removeChild(elVariantQuantity);
          elVariant.querySelector('.js-variant-row').classList.add('is-soldout');
          elVariantQuantityCell.textContent = 'SOLD OUT';
        }

        fragment.appendChild(elVariant);
      });

      this.elVariantContainer.appendChild(fragment);
      this.elVariantInputs = this.querySelectorAll('.js-variant-quantity-input');
      this.setAddCartEvent();
    }

    setAddCartEvent() {
      this.elVariantInputs.forEach((elInput) => {
        elInput.addEventListener('change', () => {
          this.updateCartItemBoard();
        })
      })
    }

    clearVariantInput() {
      this.elVariantInputs.forEach((elInput) => { elInput.value = '0'});
    }

    setDomElement() {
      this.setUnitPrice(this.constSingleId);
      this.setUnitPrice(this.constQueenId);
      this.setUnitPrice(this.constKingId);

      this.setPiecePrice();
    }

    setUnitPrice(packageType) {
      if (this.getUnitPrice(packageType) === undefined) return;

      const elUnitPrices = this.querySelectorAll(`.js-unit-price[data-package-type="${packageType}"]`);
      const unitPrice = this.getUnitPrice(packageType).toLocaleString();
      const unitComparePrice = this.getUnitComparePrice(packageType)? this.getUnitComparePrice(packageType).toLocaleString() : null;

      elUnitPrices.forEach((elPrice) => {
        if (unitComparePrice) {
          // sale
          elPrice.querySelector('.js-unit-price-normal').textContent = unitComparePrice;
          elPrice.querySelector('.js-unit-price-sale').textContent = unitPrice;
          elPrice.classList.add('is-sale');
        } else {
          // 通常価格
          elPrice.querySelector('.js-unit-price-normal').textContent = unitPrice;
        }
      })
    }

    setPiecePrice() {
      const elPieceQuantity = this.querySelector(`.js-piece-quantity`);
      if (!elPieceQuantity) return;
      const pieceQuantity = parseInt(elPieceQuantity.textContent, 10);
      const cheapestUnitPrice = this.getCheapestUnitPrice();

      // 少数点以下の端数処理(小数点第三位切り上げ)
      const piecePriceBase = (cheapestUnitPrice / pieceQuantity) * 100;
      const intPricePart = Math.trunc(piecePriceBase);
      const floatPricePart = piecePriceBase - intPricePart;

      let ceiledFloat = 0;
      // 処理しきれない端数は0.00000000000003みたいな桁になるので、10000倍しても1以下のものは0を加算。
      // それ以外の端数は切り上げのため1で計算
      if ((floatPricePart * 10000) > 1) {
        ceiledFloat = 1;
      }
      const piecePrice = (intPricePart + ceiledFloat) / 100;

      const elPiecePrices = this.querySelectorAll(`.js-piece-price`);
      elPiecePrices.forEach((elPrice) => {elPrice.textContent = piecePrice})
    }

    togglePickerClass(packageType) {
      this.elPackageTypePicker.forEach((el) => {
        el.classList.remove('is-active');

        if (el.getAttribute('data-package-type') === packageType) {
          el.classList.add('is-active');
        }
      })
    }

    switchPackageContent(packageType) {
      const ACTIVE_CLASS= 'is-active';
      const packageContents = this.querySelectorAll('.js-package-content');

      packageContents.forEach((content) => {
        content.classList.remove(ACTIVE_CLASS);

        if (packageType === content.getAttribute('data-package-type')){
          content.classList.add(ACTIVE_CLASS);
        }
      })
    }

    initTotalQuantity() {
      this.elTotalQuantity = this.querySelector('.js-total-quantity');
      const elPackageQuantities = this.querySelectorAll('.js-package-quantity');

      elPackageQuantities.forEach((el) => {
        el.addEventListener('change', () => {
          const packageType = el.getAttribute('data-package-type');
          this.updateTotalQuantity(packageType);
        })
      })
    }

    updateTotalQuantity(packageType) {
      if (packageType === this.constSingleId) return;

      const quantity = this.querySelector(`.js-package-quantity[data-package-type="${packageType}"]`).value;
      this.totalQuantity = parseInt(quantity, 10) * this.lotData[packageType];

      this.elTotalQuantity.textContent = this.totalQuantity;
    }

    toggleTotalContent(packageType) {
      const ACTIVE_CLASS= 'is-active';
      this.elTotalContent = this.elTotalContent || this.querySelector('.js-total-content');

      switch (packageType) {
        case this.constQueenId:
        case this.constKingId:
          this.elTotalContent.classList.add(ACTIVE_CLASS);
          break;
        case this.constSingleId:
          this.elTotalContent.classList.remove(ACTIVE_CLASS);
          break;
        default:
          console.log('action type error');
      }
    }

    initCartItemBoard () {
      this.elCartItemQuantity = this.elCartItemQuantity || this.querySelector('.js-cart-item-quantity');
      this.elCartItemPrice = this.elCartItemPrice || this.querySelector('.js-cart-item-price');

      this.elCartItemQuantity.textContent = 0;
      this.elCartItemPrice.textContent = 0;
    }

    updateCartItemBoard() {
      const cartItems = this.getCartItems();
      const cartItemQuantity = this.getCartItemQuantity(cartItems);

      this.elCartItemQuantity.textContent = cartItemQuantity;
      const unitPrice = this.getUnitPrice(this.selectedPackageType);
      this.elCartItemPrice.textContent = cartItemQuantity * unitPrice;
    }

    getCartItemQuantity(cartItems) {
      if (cartItems.length > 0) {
        return cartItems.map(item => item.quantity).reduce((prev, next) => prev + next);
      } else {
        return 0;
      }
    }

    getUnitPrice(packageType) {
      // 同じ梱包タイプの価格は変わらない想定で、最初の要素の価格を返す
      if (this.variantData[packageType]) {
        return this.variantData[packageType][0].price;
      }
    }
    
    getUnitComparePrice(packageType) {
      // 同じ梱包タイプの価格は変わらない想定で、最初の要素の価格を返す
      if (this.variantData[packageType]) {
        return this.variantData[packageType][0].comparePrice;
      }
    }

    getCheapestUnitPrice() {
      const priceList = [
        this.getUnitPrice(this.constSingleId),
        this.getUnitPrice(this.constQueenId),
        this.getUnitPrice(this.constKingId),
      ]

      return priceList.filter(price => price).reduce((prev, next) => prev < next ? prev : next);
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      this.submitButton = this.querySelector('[type="submit"]');
      if (this.submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      const cartItems = this.getCartItems();
      if (cartItems.length === 0) {
        this.handleErrorMessage('カートに入れる商品の数量を入力してください');
        return;
      }

      this.toggleCartButton();

      if (this.selectedPackageType === this.constQueenId || this.selectedPackageType === this.constKingId) {
        if (this.checkQuantity(cartItems)) {
          this.submitCart(cartItems);
        }
      } else {
        this.submitCart(cartItems);
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    getCartItems() {
      const variants = [];

      this.elVariantInputs.forEach((elInput) => {
        if (elInput.value && elInput.value > 0) {
          variants.push({
            id: elInput.getAttribute('data-variant-id'),
            quantity: parseInt(elInput.value, 10),
          })
        }
      })

      return variants;
    }

    checkQuantity(cartItems) {
      const cartItemQuantity = this.getCartItemQuantity(cartItems);
      const diff = cartItemQuantity - this.totalQuantity;

      if (diff === 0) {
        return true;
      } else if (diff < 0){
        //　カートインしている商品数が不足している
        const message = `
          注文数量があと${Math.abs(diff)}個足りていません。合計${this.totalQuantity}個となるように調整してください。
        `;
        this.handleErrorMessage(message);
      } else if (diff > 0) {
        //　カートインしている商品数が超えている
        const message = `
          注文数量が${Math.abs(diff)}個オーバーしています。合計${this.totalQuantity}個となるように調整してください。
        `;
        this.handleErrorMessage(message);
      }

      this.toggleCartButton();
    }

    submitCart(cartItems) {
      const config = fetchConfig('javascript');
      const data = {
        items: cartItems,
        sections: this.cartNotification.getSectionsToRender().map((section) => section.id)
      }

      config.body = JSON.stringify(data)

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartNotification.renderContents(response);
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.toggleCartButton();
          this.clearVariantInput();
        });
    }

    toggleCartButton() {
      if (this.submitButton.classList.contains('loading')) {
        this.submitButton.classList.remove('loading');
        this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      } else {
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      }
    }
  })
}